import { Icon } from '../ui/Icon.tsx';

// De ingeklapte maillijst op het tabblad Mail (desktop, ticket 28625): een strook van 44 px met één knop die de lijst weer toont
// en het aantal ongelezen mails. Dat is alle ongelezen mail volgens de server, dezelfde teller als Ongelezen in de filterbalk,
// zodat het getal klopt met Outlook (sinds 2.2.49; daarvoor telde de strook alleen de ongelezen mails in de geladen lijst).
// Staat het leesvenster rechts van de lijst, dan staat de strook links van de lezer, zoals de strook van de gesprekken
// (ChatStrip) en van de werkers (WorkersStrip), met de naam van de lijst van boven naar beneden. Staat het leesvenster onder de
// lijst (deel 2), dan ligt de strook boven de lezer, met de tekst Lijst tonen gewoon leesbaar en de teller ernaast.

/** `unread`: het aantal ongelezen mails volgens de server (`counts.unread`); null zolang de tellers niet geladen zijn.
 * `orientation`: staand (standaard) of liggend. */
export function MailListStrip(props: { unread: number | null; onExpand: () => void; orientation?: 'vertical' | 'horizontal' | undefined }) {
  const count = props.unread ? props.unread : null;
  const title = count ? `Lijst tonen (${count} ongelezen)` : 'Lijst tonen';
  const badge = count ? <span data-count="unread" className="h-5 min-w-5 px-1 rounded-full bg-accent text-white text-[12px] font-medium inline-flex items-center justify-center">{count}</span> : null;
  if (props.orientation === 'horizontal') {
    return (
      <aside className="h-11 w-full shrink-0 flex bg-paper border-b border-line" aria-label="Maillijst">
        <button type="button" aria-label="Lijst tonen" title={title} onClick={props.onExpand} className="flex-1 flex items-center gap-2 px-4 text-ink-soft hover:bg-tint hover:text-ink">
          <Icon name="chevron" size={16} className="rotate-90" />
          <span className="text-[13px] font-medium">Lijst tonen</span>
          {badge}
        </button>
      </aside>
    );
  }
  return (
    <aside className="w-11 shrink-0 h-full flex flex-col bg-paper border-r border-line" aria-label="Maillijst">
      <button type="button" aria-label="Lijst tonen" title={title} onClick={props.onExpand} className="flex-1 flex flex-col items-center gap-2 pt-2 pb-3 text-ink-soft hover:bg-tint hover:text-ink">
        <span className="h-8 w-8 inline-flex items-center justify-center rounded-md">
          <Icon name="chevron" size={16} />
        </span>
        {badge}
        <span className="text-[12px] font-medium [writing-mode:vertical-rl]">Maillijst</span>
      </button>
    </aside>
  );
}
